<template>
  <el-dialog v-bind="$attrs" :top="top" :fullscreen="fullscreen" :visible.sync="visible" :before-close="handleClose"
    :close-on-click-modal="false" :close-on-press-escape="false" :custom-class="customClass" v-if="visible" :id="`d_${id}`">
    <slot></slot>
    <template slot="title">
      <div class="el-dialog__titleBox">
        <div>{{$attrs.title}}<slot name="titleLeft"></slot></div>
        <div class="el-dialog__titleBtn">
          <slot name="titleRight"></slot>
          <i class="el-icon-full-screen" @click="toggleFullScreen" v-if="showFullScreen"></i>
          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>
    </template>
    <template slot="footer" v-if="showFooter">
      <span class="footer__tips">
        <slot name="tips"></slot>
      </span>
      <slot name="actions">
        <el-button @click="close">{{ cancelButtonText }}</el-button>
        <el-button type="primary" @click="confirm">{{ confirmButtonText }}</el-button>
      </slot>
    </template>
    <el-dialog :width="innerWidth" :title="innerTitle" :visible.sync="innerVisible" :before-close="innerClose"
      :close-on-click-modal="false" :close-on-press-escape="false" append-to-body custom-class="custom-dialog"
      v-dialog-drag v-if="innerVisible" :id="`d_${id}_inner`">
      <slot name="inner"></slot>
      <template slot="footer">
        <slot name="inner-actions">
          <el-button @click="innerClose">取 消</el-button>
          <el-button type="primary" @click="innerConfirm" v-preventReClick>确 定</el-button>
        </slot>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { tool } from '@/utils'
export default {
  name: 'yblDialog',
  props: {
    visible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    /* title: {
      type: String,
      default: function () {
        return '系统提示'
      }
    },
    width: {
      type: String | Number,
      default: function () {
        return '50%'
      }
    }, */
    top: {
      type: String | Number,
      default: function () {
        return '5vh'
      }
    },
    showFullScreen: {
      type: Boolean,
      default: () => false // 是否显示全屏按钮
    },
    showFooter: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    showHeader: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    innerTitle: {
      type: String,
      default: function () {
        return '系统提示'
      }
    },
    innerVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    innerWidth: {
      type: String | Number,
      default: () => '50%'
    },
    id: {
      type: String | Number,
      default: () => tool.UUID()
    }
  },
  data () {
    return {
      fullscreen: false // 是否全屏
      /* :title="title"
      :width="width"
      :top='top'
      :fullscreen="fullscreen" */
    }
  },
  created () {
    this.fullscreen = this.$attrs.fullscreen
  },
  computed: {
    customClass () {
      return `${!this.showHeader ? 'hidden-header' : ''} custom-dialog`
    },
    cancelButtonText () {
      return this.$attrs.cancelButtonText || '取 消'
    },
    confirmButtonText () {
      return this.$attrs.confirmButtonText || '确 定'
    }
  },
  methods: {
    handleClose () {
      this.close()
    },
    close () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm')
    },
    innerClose () {
      this.$emit('inner-close')
    },
    innerConfirm () {
      this.$emit('inner-confirm')
    },
    toggleFullScreen () {
      this.fullscreen = !this.fullscreen
    },
    calcBodyHeight (element, clientHeight) {
      // 1. 前置校验：确保必要元素存在
      if (!element || !clientHeight) return

      const dialogEle = element.querySelector('.el-dialog')
      const headerEle = element.querySelector('.el-dialog__header')
      const bodyEle = element.querySelector('.el-dialog__body')
      const footerEle = element.querySelector('.el-dialog__footer')

      // 如果核心元素缺失，直接返回，避免后续计算报错
      if (!dialogEle || !headerEle || !bodyEle) return

      const TOP_MAX_VALUE = 50

      // 2. 安全获取几何信息
      const headerRect = headerEle.getBoundingClientRect()
      const bodyRect = bodyEle.getBoundingClientRect()
      // footer 可能不存在，需兼容处理
      const footerRect = footerEle ? footerEle.getBoundingClientRect() : { height: 0 }

      // 3. 安全解析样式数值 (处理空值或非px单位情况)
      const styles = window.getComputedStyle(bodyEle)
      const parsePx = (value) => {
        if (!value) return 0
        const num = parseFloat(value)
        return isNaN(num) ? 0 : num
      }

      const paddingTop = parsePx(styles.paddingTop)
      const paddingBottom = parsePx(styles.paddingBottom)

      // 4. 计算关键变量
      // const headerHeight = headerRect.height
      const footerHeight = footerRect.height
      const bodyHeight = bodyRect.height
      const headerBottom = headerRect.bottom // 使用 bottom 更直观，等同于 top + height

      const isOverflow = (headerBottom + bodyHeight + footerHeight) > clientHeight

      if (isOverflow) {
        // 计算顶部偏移量，取 header 顶部位置和最大允许值的较小者
        const _top = Math.min(headerRect.top, TOP_MAX_VALUE)
        const calculatedMaxHeight = clientHeight - headerBottom - footerHeight - _top - paddingTop - paddingBottom

        // 确保最小高度不为负数
        const finalMaxHeight = Math.max(0, calculatedMaxHeight)

        // 6. 应用样式
        // 使用 requestAnimationFrame 减少布局抖动，或批量设置
        bodyEle.style.maxHeight = `${finalMaxHeight}px`
        dialogEle.style.marginTop = `${_top}px`
      }
    },
    resize (innerDialog = false) {
      const { id } = this
      const domClientHeight = document.documentElement.clientHeight
      const dialogSelector = `#d_${id}`

      const _this = this
      this.$nextTick(() => {
        if (innerDialog) {
          const innerDialogSelector = `${dialogSelector}_inner`
          const innerDialogEle = document.querySelector(innerDialogSelector)
          _this.calcBodyHeight(innerDialogEle, domClientHeight)
          return
        }
        const dialogEle = document.querySelector(dialogSelector)
        if (dialogEle) {
          this.calcBodyHeight(dialogEle, domClientHeight)
        }
      })
    }
  },
  watch: {
    'innerVisible': function (newVal) {
      if (newVal) {
        this.resize(newVal)
      }
    },
    'visible': function (newVal) {
      if (newVal) {
        this.resize()
      }
    }
  }
}
</script>

<style lang="less">
@border-color: #eaeaea;
@header-action-color: #909399;
.custom-dialog {
  .el-dialog__header {
    border-bottom: 1px solid @border-color;
    line-height: 20px;
  }
  .el-dialog__titleBox {
    display: flex;
    justify-content: space-between;
    .title-left {
      margin-left: 10px;
      display: inline-block;
    }
  }
  .el-dialog__titleBtn {
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      color: @header-action-color;
    }
  }
  .el-dialog__headerbtn {
    display: none;
  }
  &.hidden-header {
    .el-dialog__header {
      display: none;
    }
  }
  .el-dialog__footer {
    border-top: 1px solid @border-color;
    line-height: 20px;
  }
  .footer__tips {
    color: red;
    float: left;
    font-size: 14px;
  }
  .el-dialog__body {
    overflow: auto;
  }
}
.el-dialog.is-fullscreen {
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue